import { Network } from '@shared/types'
import { CosmosChainId } from '@shared/data/bridge'

export const getEndpointsFromChainId = (
  chainId: string
): undefined | { rpc: string; rest: string } => {
  switch (chainId) {
    case CosmosChainId[Network.InjectiveTestnet]:
      return {
        rpc: 'https://testnet.tm.injective.network',
        rest: 'https://testnet.lcd.injective.network'
      }
    case CosmosChainId[Network.CosmosHubTestnet]:
      return {
        rpc: 'https://rpc.sentry-01.theta-testnet.polypore.xyz',
        rest: 'https://rest.sentry-01.theta-testnet.polypore.xyz'
      }
    case CosmosChainId[Network.InjectiveDevnet]:
      return {
        rpc: 'https://devnet.tm.injective.dev',
        rest: 'https://devnet.lcd.injective.dev'
      }
    case CosmosChainId[Network.WormholeGeneric]:
      return {
        rpc: 'https://rpc.cosmos.directory/gateway',
        rest: 'https://rest.cosmos.directory/gateway'
      }
    case CosmosChainId[Network.Persistence]:
      return {
        rpc: 'https://rpc.cosmos.directory/persistence',
        rest: 'https://rest.cosmos.directory/persistence'
      }
    case CosmosChainId[Network.Injective]:
      return {
        rpc: 'https://sentry.tm.injective.network',
        rest: 'https://sentry.lcd.injective.network'
      }
    case CosmosChainId[Network.CosmosHub]:
      return {
        rpc: 'https://rpc.cosmos.directory/cosmoshub',
        rest: 'https://rest.cosmos.directory/cosmoshub'
      }
    case CosmosChainId[Network.Chihuahua]:
      return {
        rpc: 'https://rpc.chihuahua.wtf',
        rest: 'https://api.chihuahua.wtf'
      }
    case CosmosChainId[Network.Sommelier]:
      return {
        rpc: 'https://rpc.cosmos.directory/sommelier',
        rest: 'https://rest.cosmos.directory/sommelier'
      }
    case CosmosChainId[Network.Oraichain]:
      return {
        rpc: 'https://rpc.cosmos.directory/oraichain',
        rest: 'https://rest.cosmos.directory/oraichain'
      }
    case CosmosChainId[Network.Andromeda]:
      return {
        rpc: 'https://rpc.cosmos.directory/andromeda',
        rest: 'https://rest.cosmos.directory/andromeda'
      }
    case CosmosChainId[Network.Crescent]:
      return {
        rpc: 'https://rpc.cosmos.directory/crescent',
        rest: 'https://rest.cosmos.directory/crescent'
      }
    case CosmosChainId[Network.Celestia]:
      return {
        rpc: 'https://rpc.cosmos.directory/celestia',
        rest: 'https://rest.cosmos.directory/celestia'
      }
    case CosmosChainId[Network.Osmosis]:
      return {
        rpc: 'https://rpc.cosmos.directory/osmosis',
        rest: 'https://rest.cosmos.directory/osmosis'
      }
    case CosmosChainId[Network.Migaloo]:
      return {
        rpc: 'https://rpc.cosmos.directory/migaloo',
        rest: 'https://rest.cosmos.directory/migaloo'
      }
    case CosmosChainId[Network.Neutron]:
      return {
        rpc: 'https://rpc.cosmos.directory/neutron',
        rest: 'https://rest.cosmos.directory/neutron'
      }
    case CosmosChainId[Network.Axelar]:
      return {
        rpc: 'https://rpc.cosmos.directory/axelar',
        rest: 'https://rest.cosmos.directory/axelar'
      }
    case CosmosChainId[Network.Secret]:
      return {
        rpc: 'https://rpc.cosmos.directory/secretnetwork',
        rest: 'https://rest.cosmos.directory/secretnetwork'
      }
    case CosmosChainId[Network.Stride]:
      return {
        rpc: 'https://rpc.cosmos.directory/stride',
        rest: 'https://rest.cosmos.directory/stride'
      }
    case CosmosChainId[Network.Kujira]:
      return {
        rpc: 'https://rpc.cosmos.directory/kujira',
        rest: 'https://rest.cosmos.directory/kujira'
      }
    case CosmosChainId[Network.Mantra]:
      return {
        rpc: 'https://mantra.publicnode.com',
        rest: 'https://mantra-rest.publicnode.com'
      }
    case CosmosChainId[Network.Terra]:
      return {
        rpc: 'https://rpc.cosmos.directory/terra',
        rest: 'https://rest.cosmos.directory/terra'
      }
    case CosmosChainId[Network.Evmos]:
      return {
        rpc: 'https://rpc.cosmos.directory/evmos',
        rest: 'https://rest.cosmos.directory/evmos'
      }
    case CosmosChainId[Network.Canto]:
      return {
        rpc: 'https://rpc.cosmos.directory/canto',
        rest: 'https://rest.cosmos.directory/canto'
      }
    case CosmosChainId[Network.Noble]:
      return {
        rpc: 'https://rpc.cosmos.directory/noble',
        rest: 'https://rest.cosmos.directory/noble'
      }
    case CosmosChainId[Network.Fetch]:
      return {
        rpc: 'https://fetch-rpc.publicnode.com',
        rest: 'https://fetch-rest.publicnode.com'
      }
    case CosmosChainId[Network.Juno]:
      return {
        rpc: 'https://rpc.cosmos.directory/juno',
        rest: 'https://rest.cosmos.directory/juno'
      }
    case CosmosChainId[Network.Kava]:
      return {
        rpc: 'https://rpc.cosmos.directory/kava',
        rest: 'https://rest.cosmos.directory/kava'
      }
    case CosmosChainId[Network.Saga]:
      return {
        rpc: 'https://saga-rpc.publicnode.com',
        rest: 'https://saga-rest.publicnode.com'
      }
    case CosmosChainId[Network.Xion]:
      return {
        rpc: 'https://rpc.xion-mainnet-1.burnt.com/',
        rest: 'https://api.xion-mainnet-1.burnt.com/'
      }
    default:
      return undefined
  }
}
